module.exports = __webpack_public_path__ + "static/img/bg-pt.a211c6cf.png";